import React from 'react';
import HeroSection from './HeroSection';
import DetailsSection from './DetailsSection';

const TopStockPick: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <DetailsSection />
      <section
        className="w-full min-h-[300px] md:min-h-[500px] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/topstockpickfooter.webp')" }}
        aria-hidden="true"
      />
    </div>
  );
};

export default TopStockPick;
